// noinspection JSUnusedGlobalSymbols

export default class
{
	static show_password(button)
	{
		if($(button).text() === '表示')
		{
			$('#password').attr('type', 'text')
			$(button).text('非表示')
		}
		else
		{
			$('#password').attr('type', 'password')
			$(button).text('表示')
		}
	}
}
